export const DocumentStatus = [
  'REVIEWING',
  'VERIFIED',
  'REJECTED',
  'UPLOADING',
  'UPLOAD_FAILED',
] as const;

export type DocumentStatus = (typeof DocumentStatus)[number];

export const DEFAULT_DOCUMENT_STATUS_METADATA = { label: 'Awaiting Upload', color: 'warning' } as {
  label: string;
  color: 'positive' | 'negative' | 'warning' | 'primary';
};

export const DocumentStatusMetadata: Record<
  DocumentStatus,
  { label: string; color: 'positive' | 'negative' | 'warning' | 'primary' }
> = {
  REVIEWING: { label: 'Reviewing', color: 'primary' },
  VERIFIED: { label: 'Verified', color: 'positive' },
  REJECTED: { label: 'Rejected', color: 'negative' },
  UPLOADING: { label: 'Uploading', color: 'warning' },
  UPLOAD_FAILED: { label: 'Upload Failed', color: 'negative' },
};

type UploadStatus = 'uploading' | 'uploaded' | 'failed';

export type FileStatus = {
  name: string;
  fieldName: string;
  status: UploadStatus;
};

export type LoansFollowupFormProps = {
  setFileStatus: React.Dispatch<React.SetStateAction<FileStatus[]>>;
  fileStatus: FileStatus[];
  loanId?: string;
  onSubmit?: () => void;
};
